import { KeyRound } from "lucide-react";

function AppHeader({ onChangeApiKey }) {
  return (
    <header className="topbar">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true">
          W
        </span>
        <div>
          <strong>词境 Wordscape</strong>
        </div>
      </div>
      <button
        type="button"
        className="api-key-change"
        onClick={onChangeApiKey}
      >
        <KeyRound aria-hidden="true" size={16} strokeWidth={1.9} />
        <span>更换密钥</span>
      </button>
    </header>
  );
}

export default AppHeader;
